import type { Routes } from '@angular/router';
import { authGuard } from '@/routes/guards/auth.guard';
import { guestGuard } from '@/routes/guards/guest.guard';
import { APP_PATHS } from '@/routes/app.paths';

export interface TopbarRouteData {
  label: string;
  icon: string;
}

export interface NavRouteData {
  label: string;
  icon: string;
  nav: boolean;
  topbar?: TopbarRouteData;
}

export const AUTH_ROUTES: Routes = [
  {
    path: APP_PATHS.activity,
    data: {
      label: 'nav.activities',
      icon: 'icons/sidebar/activity_icon.svg',
      nav: true,
      topbar: {
        label: 'nav.activities',
        icon: 'icons/topbar/activity_icon.svg',
      },
    },
    loadChildren: () => import('@/routes/activity.routes').then((m) => m.ACTIVITY_ROUTES),
  },
  {
    path: APP_PATHS.offer,
    data: {
      label: 'nav.offers',
      icon: 'icons/sidebar/offers_icon.svg',
      nav: true,
      topbar: {
        label: 'nav.offers',
        icon: 'icons/topbar/offers_icon.svg',
      },
    },
    loadChildren: () => import('@/routes/offer.routes').then((m) => m.OFFERS_ROUTES),
  },
  {
    path: APP_PATHS.archive,
    data: {
      label: 'nav.archives',
      icon: 'icons/sidebar/archives_icon.svg',
      nav: true,
      topbar: {
        label: 'nav.archives',
        icon: 'icons/topbar/archives_icon.svg',
      },
    },
    loadChildren: () => import('@/routes/archive.routes').then((m) => m.ARCHIVES_ROUTES),
  },
  {
    path: APP_PATHS.brokers,
    data: {
      label: 'nav.brokers',
      icon: 'icons/sidebar/brokers_icon.svg',
      nav: true,
      topbar: {
        label: 'nav.brokers',
        icon: 'icons/topbar/brokers_icon.svg',
      },
    },
    loadChildren: () => import('@/routes/broker.routes').then((m) => m.BROKERS_ROUTES),
  },
];

export const routes: Routes = [
  { path: '', redirectTo: APP_PATHS.activity, pathMatch: 'full' },
  {
    path: '',
    canActivate: [authGuard],
    children: AUTH_ROUTES,
  },
  {
    path: APP_PATHS.login,
    canActivate: [guestGuard],
    loadComponent: () => import('@/features/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: APP_PATHS.resetPassword,
    canActivate: [guestGuard],
    loadComponent: () =>
      import('@/features/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
  },
  { path: '**', redirectTo: APP_PATHS.activity },
];
